export default {
    workVideo: null,
    moneyVideo: null,
    lifeVideo: null,
    mindbodyVideo: null,
    inspirationVideo: null,
    communityVideo: null,
    mainVideo: null,
    aboutusVideo: null,
    marketingPlanId: null,
    workLearnMore: null,
    moneyLearnMore: null,
    lifeLearnMore: null,
    communityLearnMore: null,
    mindbodyLearnMore: null,
    liveEventVideo: null,
    triggerLogin: false,
    corporateGiftingCode: '',
    corporateClientId: 0,
    allUnauthVideos: null,
    allTestimonials: null,
    companyLogos: null,
    corpReference: null
}



// WEBPACK FOOTER //
// ./src/store/unauthpage/state.js